import RyderLivescoringModalPortal from "@/components/RyderLivescoring/RyderLivescoringModalPortal"
import React from "react"

const RyderLivescoringTeamNin9rsView = ({
    tbd,
    isRight,
    teamColor,
    showElectronicCard,
    side,
    players,
    showResult,
    result,
    holeInProgress,
    match,
    modalUrl,
    setModalUrl
}) => {

    if (tbd) {
        return (
            <>
                {/* Desktop */}
                <div className="hidden sm:block w-1/2 p-4">
                    <div
                        className={`font-bold text-2xl text-black xl:text-4xl 2xl:text-6xl ${isRight ? "text-right" : ""}`}>
                        TBD
                    </div>
                </div>
                {/* Mobile */}
                <div className={`sm:hidden p-4 ${isRight ? "border-t border-gray-300" : ""}`}>
                    <div className="font-bold text-xl text-black">TBD</div>
                </div>
            </>
        )
    }

    return (
        <>
            <div onClick={() => showElectronicCard(side)} className={`matchLine ${teamColor} ${isRight ? "right" : "left"}`}>
                <div className="grid gap-2 py-2">
                    {players.map((player) => (
                        <div key={player.id} className={`matchPlayerLine ${isRight ? "right" : "left"}`}>
                            <div className="matchPlayerScoreContainer">
                                <svg className="matchPlayerScore" xmlns="http://www.w3.org/2000/svg" width="125"
                                     height="108" viewBox="0 0 125 108"
                                     fill="none">
                                    <path
                                        d={isRight ? "M14.4961 101.251L21.6689 94.0852L23.4287 92.3274V6.00024H118.68V85.345L102.773 101.251H14.4961Z" : "M110.184 6L103.011 13.166L101.251 14.9238V101.251H6V21.9062L21.9062 6H110.184Z"}
                                        fill="#0C0C0C" stroke={isRight ? "url(#paint0_linear_324_917)" : "url(#paint0_linear_324_905)"} strokeWidth="12"/>
                                    <defs>
                                        <linearGradient
                                            id={isRight ? "paint0_linear_324_917" : "paint0_linear_324_905"}
                                            x1={isRight ? "62.3399" : "62.3398"}
                                            y1={isRight ? "2.28882e-05" : "0"}
                                            x2={isRight ? "62.3399" : "62.3398"}
                                            y2="107.251"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor={teamColor}/>
                                            <stop offset="1" stopColor={teamColor}/>
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <div className="matchPlayerScoreNumberContainer">
                                    <label className={`matchPlayerScoreNumber ${isRight ? "right" : "left"}`}>
                                        {player.hcpj}
                                    </label>
                                </div>
                            </div>
                            <svg
                                className="playerImageFrame"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 77 66"
                                fill="none"
                            >
                                <path
                                    d="M66.8916 3.84961L62.8213 7.91602L61.6924 9.04395V61.6924H3.84961V13.4639L13.4639 3.84961H66.8916Z"
                                    fill={`url(#pattern${player.id})`}
                                    stroke={teamColor}
                                    strokeWidth="7.7"
                                />
                                <defs>
                                    <pattern
                                        id={`pattern${player.id}`}
                                        patternContentUnits="objectBoundingBox"
                                        width="0.854995"
                                        height="0.991944"
                                        patternTransform={isRight ? "rotate(180) translate(-11, -10)" : ""}
                                    >
                                        <use xlinkHref={`#image${player.id}`} transform="scale(0.000854995 0.000993932)"/>
                                    </pattern>
                                    <image id={`image${player.id}`} width="1000" height="998"
                                           preserveAspectRatio="none" xlinkHref={player.imageUrl ? player.imageUrl : "/img/avatar/default-golfer.webp"}/>
                                </defs>
                            </svg>
                            <div className="matchPlayerNameRelativeContainer">
                                <svg className="matchPlayerNameContainer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 390 108" fill="none">
                                    <path d="M389.32 0V88.6729L370.741 107.251H0V18.9598L18.9606 0H389.32Z" fill="#0C0C0C"/>
                                </svg>
                                <div className="matchPlayerNameContent">
                                    <div className="matchPlayerNames">
                                        <label>
                                            {player.name}
                                        </label>
                                        <label>
                                            {player.surname}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {
                    showResult &&
                    <div className="matchResult" style={{background: teamColor}}>
                        <span className="advantage">{result}</span>
                        <span className="currentRound">{holeInProgress(match)}</span>
                    </div>
                }
            </div>
            {modalUrl && (
                <RyderLivescoringModalPortal>
                    <div
                        onClick={() => setModalUrl(null)}
                        className="fixed inset-0 z-50 flex items-center justify-center bg-stone-900"
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            className="relative bg-white rounded-lg shadow-2xl overflow-hidden"
                            style={{
                                width: 'calc(100% - 2rem)',
                                maxWidth: '48em',
                                height: '90vh',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <div className="flex justify-end items-start p-2 bg-white border-b border-gray-200">
                                <button
                                    onClick={setModalUrl.bind(null, null)}
                                    className="cursor-pointer w-10 h-10 rounded-full border border-gray-300 bg-white flex items-center justify-center text-3xl text-slate-600 hover:text-slate-800 shadow transition"
                                    aria-label="Cerrar"
                                >
                                    ×
                                </button>
                            </div>

                            <div className="flex-1">
                                <iframe
                                    src={modalUrl}
                                    title="Tarjeta electrónica"
                                    className="w-full h-full"
                                    allowFullScreen
                                />
                            </div>
                        </div>
                    </div>
                </RyderLivescoringModalPortal>
            )}
        </>
    )
}

export default RyderLivescoringTeamNin9rsView
